export class ValidationMessages {

  public libelleDemande = 'validation.libelleDemande';
  public libelleElement = 'validation.libelleElement';
  public description = 'validation.description';
  public typeAvis = 'validation.typeAvis';
  public choixForm = 'validation.choixForm';
  public choixSupport = 'validation.choixSupport';
  public supportDiffusion = 'validation.supportDiffusion';
  public redactionAvis = 'validation.redactionAvis';
  public denomination = 'validation.denomination';

  constructor() {
  }
}
